export default "__VITE_ASSET__b6466978__"